import React from 'react';
import { SvgIcon } from '@mui/material';
import { iconType } from './icon-types';

const SortDescending = (properties: iconType) => {
  const { height, width, fill } = properties;
  return (
    <SvgIcon
      viewBox="0 0 24 20"
      style={{
        width: width || '24',
        height: height || '20',
        fill,
      }}
      {...properties}
    >
      <path d="M12.692 18.9997L12.692 16.3844L23 16.3844L23 18.9997L12.692 18.9997ZM12.4613 19.9997L23.2307 19.9997C23.6554 19.9997 24 19.6551 24 19.2305L24 16.1536C24 15.729 23.6554 15.3844 23.2307 15.3844L12.4613 15.3844C12.0366 15.3844 11.692 15.729 11.692 16.1536L11.692 19.2305C11.692 19.6551 12.0366 19.9997 12.4613 19.9997Z" />
      <path d="M7.5075 4.95405L5.1795 2.62614L5.1795 19.2305C5.1795 19.6551 4.83488 19.9997 4.41026 19.9997C3.98563 19.9997 3.64101 19.6551 3.64101 19.2305L3.641 2.62614L1.31301 4.95405C1.013 5.25443 0.525297 5.25443 0.22529 4.95405C-0.0751016 4.65367 -0.0751017 4.16675 0.22529 3.86637L3.86639 0.22541C4.0164 0.0750272 4.21332 3.02585e-05 4.41025 3.02463e-05C4.60718 3.02342e-05 4.80411 0.0750272 4.95411 0.22541L8.59521 3.86637C8.89561 4.16675 8.89561 4.65367 8.59521 4.95405C8.29521 5.25443 7.8075 5.25443 7.5075 4.95405Z" />
      <path d="M12.692 12.8461L12.692 10.2308L20.6922 10.2308L20.6922 12.8461L12.692 12.8461ZM12.4613 13.8461L20.923 13.8461C21.3476 13.8461 21.6922 13.5015 21.6922 13.0769L21.6922 10C21.6922 9.57543 21.3476 9.23082 20.923 9.23082L12.4613 9.23082C12.0366 9.23082 11.692 9.57543 11.692 10L11.692 13.0769C11.692 13.5015 12.0366 13.8461 12.4613 13.8461Z" />
      <path d="M12.692 6.69263L12.692 4.07732L17.6153 4.07732L17.6153 6.69263L12.692 6.69263ZM12.4613 7.69263L17.846 7.69263C18.2706 7.69263 18.6153 7.34802 18.6153 6.92341L18.6153 3.84654C18.6153 3.42193 18.2706 3.07732 17.846 3.07732L12.4613 3.07732C12.0366 3.07732 11.692 3.42193 11.692 3.84654L11.692 6.92341C11.692 7.34802 12.0366 7.69263 12.4613 7.69263Z" />
    </SvgIcon>
  );
};

export default SortDescending;
